import api from 'api';

export const loadConceptFamiliesGrid = api(
  'POST /api/gallery-concept-families/grid'
);

export const loadConceptFamily = api('GET /api/gallery-concept-families/:id');
export const loadConceptFamilyDetails = api(
  'GET /api/gallery-concept-families/:id/details'
);

export const createConceptFamily = api('POST /api/gallery-concept-families');
export const updateConceptFamily = api('PUT /api/gallery-concept-families/:id');
export const removeConceptFamily = api(
  'POST /api/gallery-concept-families/delete'
);

export const loadAttachments = api(
  'GET /api/gallery-concept-families/:id/attachments'
);
export const uploadAttachments = api(
  'POST /api/gallery-concept-families/upload-attachments'
);
